import availableLanguages from '../../../config/localization/availableLanguages'
import {isNullOrUndefined} from "util";

const formDataBase = data => {

  const form = new FormData()

  //Only when creating and updating from home client
  if (!isNullOrUndefined(data.title)) {
    availableLanguages.forEach(language => {
      form.append(`translations[${language}][title]`, data.title)
    })
  }
  if (!isNullOrUndefined(data.subtitle)) {
    availableLanguages.forEach(language => {
      form.append(`translations[${language}][subtitle]`, data.subtitle)
    })
  }
  //---------

  if (data.translations) {
    data.translations.forEach(translation => {
      if (!isNullOrUndefined(translation.title)) form.append(`translations[${translation.language}][title]`, translation.title)
      if (!isNullOrUndefined(translation.subtitle)) form.append(`translations[${translation.language}][subtitle]`, translation.subtitle)
    })
  }
  if (data.description) form.append('description', data.description)
  if (!isNullOrUndefined(data.visibility)) form.append('visibility', data.visibility ? 'public' : 'private')
  if (data.imageFile) form.append('image', data.imageFile, data.imageFile.name)
  if (data.selectedContent) data.selectedContent.forEach(x => form.append('content_ids[]', x.id))
  if (data.orderType) form.append('order_type', data.orderType)

  return form
}

export const makeFormData = data => {
  const form = formDataBase(data)
  return form
}

export const makeGlobalFormData = data => {
  data.visibility = true
  const form = formDataBase(data)
  if (data.type) form.append('type', data.type)
  if (data.order) form.append('order', data.order)
  if (data.selectedTags) data.selectedTags.forEach(x => form.append('tags_ids[]', x))
  if (data.unselectedTags) data.unselectedTags.forEach(x => form.append('not_tags_ids[]', x))
  if (data.query) form.append('query', data.query)
  return form
}

export const includeQuery = 'include=translations;user;category'
